export const intelColors = {
  primary: '#1976d2',
  primaryDark: '#1565c0',
  red: '#e53935',
  redDark: '#c62828',
  orange: '#f57c00',
  orangeDark: '#e65100',
  green: '#43a047',
  greenDark: '#2e7d32',
  purple: '#7b1fa2',
  purpleDark: '#6a1b9a',
  text: '#212121',
  subtext: '#666',
  muted: '#888',
  border: '#e8ecf1',
  surfaceBg: '#fff',
  pageBg: '#f0f2f5',
  rowHover: '#f8fafd',
  headRowBg: '#f8f9fb',
  badgeRedBg: '#ffebee',
  badgeOrangeBg: '#fff3e0',
  badgeGreenBg: '#e8f5e9',
  badgeBlueBg: '#e3f2fd',
  badgeGreyBg: '#f5f5f5',
  badgePurpleBg: '#f3e5f5',
}

export const kpiBorderColor = {
  blue: intelColors.primary,
  red: intelColors.red,
  orange: intelColors.orange,
  green: intelColors.green,
  purple: intelColors.purple,
  grey: intelColors.muted,
}

export const badgePalette = {
  red: { bg: intelColors.badgeRedBg, color: intelColors.redDark },
  orange: { bg: intelColors.badgeOrangeBg, color: intelColors.orangeDark },
  green: { bg: intelColors.badgeGreenBg, color: intelColors.greenDark },
  blue: { bg: intelColors.badgeBlueBg, color: '#1565c0' },
  grey: { bg: intelColors.badgeGreyBg, color: '#555' },
  purple: { bg: intelColors.badgePurpleBg, color: intelColors.purpleDark },
}

export const formatPct = (v) => {
  if (v === null || v === undefined || isNaN(v)) return '—'
  return `${Number(v).toFixed(1)}%`
}

export const formatNumber = (v) => {
  if (v === null || v === undefined || isNaN(v)) return '—'
  return Number(v).toLocaleString('en-IN')
}

export const formatDelta = (v, unit = '%', decimals = 1) => {
  if (v === null || v === undefined || isNaN(v)) return { text: '—', color: intelColors.muted }
  const num = Number(v)
  // decimals=0 → integer (pin counts); otherwise fixed decimals (percentages)
  const mag = decimals === 0 ? Math.round(num).toLocaleString('en-IN') : num.toFixed(decimals)
  if (num > 0) return { text: `▲ +${mag}${unit}`, color: intelColors.green }
  if (num < 0) return { text: `▼ ${mag}${unit}`, color: intelColors.red }
  return { text: `— ${mag}${unit}`, color: intelColors.muted }
}

export const trendIcon = (dir) => {
  switch ((dir || '').toUpperCase()) {
    case 'UP':
      return '📈'
    case 'DOWN':
      return '📉'
    default:
      return '➡️'
  }
}
